import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TreeNode } from 'primeng/api';
import { ToastService } from '../../../../services/toast.service';
import { Modulo } from '../../../../types/Modulo.type';
import { Perfil } from '../../../../types/Perfil.type';
import { PerfilService } from '../perfil.service';

@Component({
  selector: 'app-perfilform',
  templateUrl: './perfilform.component.html',
  styleUrl: './perfilform.component.css',
})
export class PerfilformComponent {
  perfil: Perfil = {} as Perfil;
  perfilEnviado: boolean = false;

  permissoes: TreeNode[] = [];
  permissoesSelecionadas: TreeNode[] = [];

  constructor(
    private perfilService: PerfilService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    let id = this.activatedRoute.snapshot.paramMap.get('id');
    this.perfilService.getPermissoes().subscribe((value) => {
      this.permissoes = this.buildTree(value);

      if (id) {
        this.perfilService.getOne(id!).subscribe({
          next: (valor) => {
            this.perfil = valor;

            this.selecioneNode(this.permissoes);
          },
        });
      }

      this.permissoes = [];
      this.permissoes = this.buildTree(value);
    });
  }

  salvar() {
    this.perfilEnviado = true;

    if (this.perfilEnviado && this.perfil.nomePerfil?.trim()) {
      this.perfil.modulos = [];

      this.permissoesSelecionadas.forEach((perm) => {
        var modulo: Modulo = {} as Modulo;

        modulo.id = perm.key || '';

        if(!this.perfil.modulos.some(child => child.id == perm.key))
          this.perfil.modulos.push({ id: perm.key } as Modulo);
      });

      if (this.perfil.id) {
        this.perfilService.put(this.perfil).subscribe({
          next: () => {
            this.toastService.sucesso(
              'Sucesso',
              'Perfil atualizado com sucesso'
            );
            this.router.navigate(['administracao', 'perfil']);
          },
          error: (value) => {
            this.toastService.erro('Erro', 'Erro ao atualizar: ' + value);
          },
          complete: () => {
            this.perfilEnviado = false;
          },
        });
      } else {
        this.perfil.clienteId = this.activatedRoute.snapshot.queryParams["cliente"]
        this.perfilService.post(this.perfil).subscribe({
          next: () => {
            this.toastService.sucesso('Sucesso', 'Perfil criado com sucesso');

            if (this.perfil.clienteId && this.perfil.clienteId.trim()) {
              this.router.navigate([
                '/',
                'administracao',
                'clientes',
                'editar',
                this.perfil.clienteId,
              ]);
            } else {
              this.router.navigate(['administracao', 'perfil']);
            }
          },
          error: (value) => {
            this.toastService.erro('Erro', 'Erro ao salvar: ' + value);
          },
          complete: () => {
            this.perfilEnviado = false;
          },
        });
      }

      console.log(this.perfil);
    } else {
      this.toastService.alerta(
        'Campos obrigatórios',
        'Necessário informar um nome ao perfil'
      );
    }
  }

  buildTree(data: any): TreeNode[] {
    return data.map((item: any) => this.createNode(item));
  }

  createNode(item: any): TreeNode {
    return {
      label: item.descricao,
      data: item,
      key: item.id,
      children: item.modulosFilhos.map((child: any) => this.createNode(child)),
    };
  }

  selecioneNode(itens: TreeNode[]) {
    itens.forEach((item) => {
      if (item.children) this.selecioneNode(item.children);

      this.perfil.modulos
        .filter((mod) => mod.id == item.key)
        .map((it) => {this.permissoesSelecionadas.push(item);});

        
    });
  }

  onNodeSelect(event: any) {
    this.updateParentSelection(event.node);
  }
  onNodeUnselect(event: any) {
    this.updateParentSelection(event.node);
  }
  updateParentSelection(node: TreeNode) {
    
    if (node.parent) {
      const parent = node.parent;

      console.log(parent)

      console.log(this.permissoesSelecionadas)

      const allChildrenSelected = parent.children?.every((child) =>
        this.permissoesSelecionadas.includes(child)
      );
      const someChildrenSelected = parent.children?.some((child) =>
      {

        return this.permissoesSelecionadas.filter(p => p.key == child.key).length > 0

      });
      
      if (allChildrenSelected) {
        if (!this.permissoesSelecionadas.includes(parent)) {
          this.permissoesSelecionadas.push(parent);
        }
      } else if (someChildrenSelected) {
        if (!this.permissoesSelecionadas.includes(parent)) {
          this.permissoesSelecionadas.push(parent);
        }
      } 
      this.updateParentSelection(parent);
    }
  }
}
